import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../api/api.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  public profileForm: any;
  submitted = false;
  file: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router ) { }

  ngOnInit(): void {

    this.profileForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      mobile: [null, [Validators.required, Validators.pattern('[0-9]+'), Validators.minLength(10) ]],
      password: [null, [Validators.required, Validators.minLength(8)]],
    });

  }



// onSubmit() {
//   console.log(this.skillsForm.value);
// }

  get f() { return this.profileForm.controls; }

  onSubmit() {
  console.log(this.profileForm.value);

    // this.router.navigateByUrl('/otrform');

    this.submitted = true;

    if (this.profileForm.invalid) {
      return;
  }

  console.log(this.profileForm.value);



  // this.profileForm.value ={
  //   file:this.file
  // }

  //Object.assign(this.profileForm.value, {file:this.file});

  console.log(this.profileForm.value);

  this.api.otr(this.profileForm.value).subscribe((result:any)=>{
    //console.log(this.aFormGroup.controls);
    console.log(result);
  });

  window.localStorage.setItem("mobile", this.profileForm.mobile);

  this.router.navigateByUrl('/otrform');


  console.log(JSON.stringify(this.profileForm.value));
    //console.log(this.aFormGroup.controls);
    this.profileForm.reset();
  }

  handleSuccess(e: any) {
    console.log("ReCaptcha", e);
  }
}
